<template>
  <div class="custom-dropdown" @click="toggleDropdown" :tabindex="0" @blur="closeDropdown" ref="dropdown">
    <div class="selected-value">
      <span v-if="selectedOption">{{ selectedOption.text }}</span>
      <span v-else>{{ placeholder }}</span>
      <img :src="chevronDown" alt="chevron down" :class="['custom-arrow', { 'flipped': open }]" />
    </div>
    <div v-if="open" class="dropdown-menu">
      <div
        v-for="option in options"
        :key="option.value"
        :class="['dropdown-item', { selected: selectedOption && option.value === selectedOption.value }]"
        @click.stop="selectOption(option)"
      >
        <div class="selected-bar" v-if="selectedOption && option.value === selectedOption.value"></div>
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>
import chevronDown from '@/assets/dashboard/chevron-down.png';
export default {
  name: 'Dropdown',
  props: {
    value: String,
    options: {
      type: Array,
      default: () => [
        { text: 'Gráfico de linha', value: 'line' },
        { text: 'Gráfico de barras', value: 'bar' }
      ]
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: false,
      chevronDown
    }
  },
  computed: {
    selectedOption() {
      if (this.value === null || this.value === undefined || this.value === '') {
        return null;
      }
      return this.options.find(opt => opt.value === this.value) || null;
    }
  },
  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    closeDropdown() {
      this.open = false;
    },
    selectOption(option) {
      this.$emit('input', option.value);
      this.open = false;
    }
  }
}
</script>

<style scoped>
.custom-dropdown {
  position: relative;
  min-width: 180px;
  max-width: 220px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.10);
  background: #fff;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  user-select: none;
  border: 1px solid #DBDBDB;
}
.selected-value {
  padding: 10px 36px 10px 16px;
  border-radius: 12px;
  position: relative;
}
.custom-arrow {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
  transition: transform 0.2s;
}
.custom-arrow.flipped {
  transform: translateY(-50%) rotate(180deg);
}
.dropdown-menu {
  position: absolute;
  left: 0;
  right: 0;
  top: 110%;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.13);
  z-index: 10;
  padding: 8px 0;
}
.dropdown-item {
  font-size: 15px;
  font-family: Arial, sans-serif;
  padding: 10px 18px 10px 16px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
}
.dropdown-item.selected {
    border-left: var(--Raio-de-canto-SM, 2px) solid var(--primrio-azul-11, #1D8AFF);
    background: var(--primrio-branco-11, #FFF);
}

.dropdown-item:not(.selected):hover {
  background: #f0f4fa;
}
</style>
